
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"version":"1.1","id":"Livello_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 131.6 55.8","xml:space":"preserve"}},[_c('path',{attrs:{"d":"M94 39.5c1.5.1 3 .2 4.4.4V13.7H94v25.8zm-71.4-9.7l-5.8-16h-4.2v28.3c1.5-.2 3-.4 4.4-.6V26.1l5.1 14.8c1.6-.2 3.2-.4 4.9-.5V13.7h-4.4v16.1zm8.7 10.1c4.1-.4 8.2-.7 12.3-.9v-4.4c-2.6.2-5.3.3-7.9.5v-6.6c1.7 0 4-.1 6 0v-4.4h-6v-6h7.9v-4.4H31.3v26.2zm15.2-21.7h4.6v20.5c1.5-.1 3-.1 4.4-.1V18.2h4.6v-4.4H46.5v4.4zm16.6 20.2h4.4V28.3h6v-4.4h-6v-5.7h8v-4.4H63.1v24.6zm55-24.7h-4.9l-3.2 7.5-2.9-7.5h-4.8l5.2 13.3-5.6 13.1c1.6.2 3.1.3 4.7.5l3.3-7.6 3.2 8.4c1.7.2 3.4.4 5.1.7l-5.8-14.9 5.7-13.5zm-35.4 0h-4.4v24.8c4 .1 8.1.3 12.1.6v-4.4c-2.5-.2-5.1-.3-7.6-.4V13.7z","fill":"#e01f1d"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      